// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2j-QF","form":"styles_form__1oJBk"};